import React, { Component } from "react";
import { connect } from "react-redux";
import { pmaActions } from "_store/_actions";
import { GetStateStorage } from "common/storage";
import { WebsiteLayout } from "layouts";
import { CircularProgress, Typography } from '@mui/material';
import { withRouter } from "common/utils/router.util";
import MailProInit from "./MailProInit";
import { isEmpty } from "lodash";

class MailProMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
    };
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
  }

  componentDidMount() {
    const stateData = GetStateStorage();
    const agentData = stateData.userData;
    this.props.getNextPMAPrintDate(agentData);

    const { mlsAreas, switchArea, history } = this.props;
    let paramAreaID = this.props.match?.params?.areaID;
    let areaIDList = agentData.navbarInfo.map((area) => String(area.mlsAreaID));
    // If the URL area doesn't belong to this agent (e.g. admin session switch),
    // fall back to the agent's first area.
    let idMatches = areaIDList.indexOf(String(paramAreaID)) >= 0;

    let navbarInfo = {};
    if (agentData && Array.isArray(agentData.navbarInfo)) {
      if (!idMatches) {
        navbarInfo = agentData.navbarInfo[0];
        history.push(`/mailpro/${agentData.navbarInfo[0].mlsAreaID}`);
      } else {
        navbarInfo = agentData.navbarInfo.filter(
          (area) => String(area.mlsAreaID) === String(paramAreaID)
        )[0];
      }
    }

    // Only call switchArea if mlsAreas is empty to avoid resetting propertyData
    if ((!mlsAreas || mlsAreas.length === 0) && navbarInfo && navbarInfo.mlsAreaID) {
      switchArea(navbarInfo, false);
    }
    if (!this.props.mlsAreas || this.props.mlsAreas.length === 0) {
      this.props.getNavbarInfo(stateData.userData.listgenUserID, navbarInfo);
    }

    window.scrollTo(0, 0);
  }

  handleDrawerOpen = () => {
    this.setState({ openDrawer: true });
  };

  handleDrawerClose = () => {
    this.setState({ openDrawer: false });
  };

  render() {
    const { mlsAreas, currentArea, propertyData } = this.props;
    const stateData = GetStateStorage() || {};
    const agentData = stateData.userData;

    let paramAreaID = this.props.match?.params?.areaID;
    const isUnavailable = !agentData.pmaScheduleID;

    return (
      <WebsiteLayout
        sidebarMode={true}
        openSidebarModeSidebar={this.state.openDrawer}
        sidebarModeHandleClose={this.handleDrawerClose}
        hideFooter={true}
      >
        {mlsAreas && mlsAreas.length >= 1 && !isEmpty(currentArea) ? (
          <MailProInit
            agentData={agentData}
            mlsAreas={mlsAreas}
            navbarData={currentArea}
            handleDrawerOpen={this.handleDrawerOpen}
            // Read directly from session storage on every render instead of
            // component state. The old pattern stored this in state via
            // componentDidMount, which meant the first render always passed
            // false (constructor default) — causing a "window not open" flash
            // that lasted until getNavbarInfo completed and triggered a
            // re-render. Session storage already has the correct value from
            // the session switch, so reading here is always accurate.
            enableMailProApprovalProcess={agentData.enableApprovalButton || false}
            paramAreaID={paramAreaID}
            propertyData={propertyData}
            isUnavailable={isUnavailable}
          />
        ) : (
          <div
            style={{
              height: "80vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              background: "inherit",
            }}
          >
            <div>
              <CircularProgress />
            </div>
            <div>
              <Typography variant="subtitle2">
                &nbsp;&nbsp;Loading...
              </Typography>
            </div>
          </div>
        )}
      </WebsiteLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentArea: state.pma.currentArea,
    mlsAreas: state.pma.mlsAreas,
    propertyData: state.pma.propertyData,
    nextPMAPrintDate: state.pma.nextPMAPrintDate,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getNavbarInfo: (listgenUserID) =>
      dispatch(pmaActions.getNavbarInfo(listgenUserID)),
    switchArea: (area, isLoading) =>
      dispatch(pmaActions.switchArea(area, isLoading)),
    getNextPMAPrintDate: (agentData) =>
      dispatch(pmaActions.getNextPMAPrintDate(agentData)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MailProMain));
